export const languages = {
	'zh-CN': {
		centerTimeMomentConfig: {
			sameDay: '[今天] HH:mm:ss',
			nextDay: '[明天] HH:mm:ss',
			nextWeek: 'dddd H:mm:ss',
			lastDay: '[昨天] HH:mm:ss',
			lastWeek: 'YY-MM-DD HH:mm:ss',
			sameElse: 'YYYY-MM-DD HH:mm:ss',
		},
		sendTimeFullMomentConfig: {
			sameDay: '[今天] HH:mm:ss',
			nextDay: '[明天] HH:mm:ss',
			nextWeek: 'dddd H:mm:ss',
			lastDay: '[昨天] HH:mm:ss',
			lastWeek: 'YY-MM-DD HH:mm:ss',
			sameElse: 'YYYY-MM-DD HH:mm:ss',
		},
		dialogTimeMomentConfig: {
			sameDay: 'HH:mm',
			nextDay: '[明天] HH:mm',
			nextWeek: 'dddd',
			lastDay: '[昨天] HH:mm',
			lastWeek: 'YY-MM-DD',
			sameElse: 'YYYY-MM-DD',
		},
		lastSeenTimeMomentConfig: {
			sameDay: '[上次上线在] HH:mm',
			nextDay: '[上次上线在 明天] HH:mm',
			nextWeek: 'dddd',
			lastDay: '[上次上线在 昨天] HH:mm',
			lastWeek: '[上次上线在] YY-MM-DD',
			sameElse: '[上次上线在] YYYY-MM-DD',
		},
		sendTimeMomentConfig: {
			sameDay: 'H:mm',
			nextDay: 'H:mm',
			nextWeek: 'H:mm',
			lastDay: 'H:mm',
			lastWeek: 'H:mm',
			sameElse: 'H:mm',
		},
		calledOnAnotherDevice: '在另一台设备上调用',
		notConnected: '未连接',
		in: '正在',
		callDuration: '通话时长 ',
	},
	'zh-TW': {
		centerTimeMomentConfig: {
			sameDay: '[今天] HH:mm:ss',
			nextDay: '[明天] HH:mm:ss',
			nextWeek: 'dddd H:mm:ss',
			lastDay: '[昨天] HH:mm:ss',
			lastWeek: 'YY-MM-DD HH:mm:ss',
			sameElse: 'YYYY-MM-DD HH:mm:ss',
		},
		sendTimeFullMomentConfig: {
			sameDay: '[今天] HH:mm:ss',
			nextDay: '[明天] HH:mm:ss',
			nextWeek: 'dddd H:mm:ss',
			lastDay: '[昨天] HH:mm:ss',
			lastWeek: 'YY-MM-DD HH:mm:ss',
			sameElse: 'YYYY-MM-DD HH:mm:ss',
		},
		dialogTimeMomentConfig: {
			sameDay: 'HH:mm',
			nextDay: '[明天] HH:mm',
			nextWeek: 'dddd',
			lastDay: '[昨天] HH:mm',
			lastWeek: 'YY-MM-DD',
			sameElse: 'YYYY-MM-DD',
		},
		lastSeenTimeMomentConfig: {
			sameDay: '[上次上線在] HH:mm',
			nextDay: '[上次上線在 明天] HH:mm',
			nextWeek: 'dddd',
			lastDay: '[上次上線在 昨天] HH:mm',
			lastWeek: '[上次上線在] YY-MM-DD',
			sameElse: '[上次上線在] YYYY-MM-DD',
		},
		sendTimeMomentConfig: {
			sameDay: 'H:mm',
			nextDay: 'H:mm',
			nextWeek: 'H:mm',
			lastDay: 'H:mm',
			lastWeek: 'H:mm',
			sameElse: 'H:mm',
		},

		calledOnAnotherDevice: '在另一台設備上調用',
		notConnected: '未連接',
		in: '正在',
		callDuration: '通話時長 ',
	},
	'en-US': {
		centerTimeMomentConfig: {
			sameDay: '[Today] HH:mm:ss',
			nextDay: '[Tomorrow] HH:mm:ss',
			nextWeek: 'dddd H:mm:ss',
			lastDay: '[Yesterday] HH:mm:ss',
			lastWeek: 'YY-MM-DD HH:mm:ss',
			sameElse: 'YYYY-MM-DD HH:mm:ss',
		},
		sendTimeFullMomentConfig: {
			sameDay: '[Today] HH:mm:ss',
			nextDay: '[Tomorrow] HH:mm:ss',
			nextWeek: 'dddd H:mm:ss',
			lastDay: '[Yesterday] HH:mm:ss',
			lastWeek: 'YY-MM-DD HH:mm:ss',
			sameElse: 'YYYY-MM-DD HH:mm:ss',
		},
		dialogTimeMomentConfig: {
			sameDay: 'HH:mm',
			nextDay: '[Tomorrow] HH:mm',
			nextWeek: 'dddd',
			lastDay: '[Yesterday] HH:mm',
			lastWeek: 'YY-MM-DD',
			sameElse: 'YYYY-MM-DD',
		},
		lastSeenTimeMomentConfig: {
			sameDay: '[last seen at] HH:mm',
			nextDay: '[Tomorrow] HH:mm',
			nextWeek: 'dddd',
			lastDay: '[last seen yesterday at] HH:mm',
			lastWeek: '[last seen ] YY-MM-DD',
			sameElse: '[last seen ] YYYY-MM-DD',
		},
		sendTimeMomentConfig: {
			sameDay: 'H:mm',
			nextDay: 'H:mm',
			nextWeek: 'H:mm',
			lastDay: 'H:mm',
			lastWeek: 'H:mm',
			sameElse: 'H:mm',
		},

		calledOnAnotherDevice: 'Called on another device',
		notConnected: ' not connected',
		in: 'In ',
		callDuration: 'Call duration ',
	},
}

export const l = (language: string, name: string) => {
	return (languages as any)[language][name]
}
